/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The order to return the responses in by creation date. 'asc' returns oldest responses first, 'desc' returns newest responses first. Defaults to 'desc' (newest first).
 */
export const ListResponsesQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
/**
 * The order to return the responses in by creation date. 'asc' returns oldest responses first, 'desc' returns newest responses first. Defaults to 'desc' (newest first).
 */
export type ListResponsesQueryParamOrder = ClosedEnum<
  typeof ListResponsesQueryParamOrder
>;

export type ListResponsesRequest = {
  after?: string | undefined;
  before?: string | undefined;
  limit?: number | undefined;
  /**
   * The order to return the responses in by creation date. 'asc' returns oldest responses first, 'desc' returns newest responses first. Defaults to 'desc' (newest first).
   */
  order?: ListResponsesQueryParamOrder | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListResponsesQueryParamOrder$inboundSchema: z.ZodNativeEnum<
  typeof ListResponsesQueryParamOrder
> = z.nativeEnum(ListResponsesQueryParamOrder);
/** @internal */
export const ListResponsesQueryParamOrder$outboundSchema: z.ZodNativeEnum<
  typeof ListResponsesQueryParamOrder
> = ListResponsesQueryParamOrder$inboundSchema;

/** @internal */
export const ListResponsesRequest$inboundSchema: z.ZodType<
  ListResponsesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  after: z.string().optional(),
  before: z.string().optional(),
  limit: z.number().int().default(20),
  order: ListResponsesQueryParamOrder$inboundSchema.default("desc"),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListResponsesRequest$Outbound = {
  after?: string | undefined;
  before?: string | undefined;
  limit: number;
  order: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListResponsesRequest$outboundSchema: z.ZodType<
  ListResponsesRequest$Outbound,
  z.ZodTypeDef,
  ListResponsesRequest
> = z.object({
  after: z.string().optional(),
  before: z.string().optional(),
  limit: z.number().int().default(20),
  order: ListResponsesQueryParamOrder$outboundSchema.default("desc"),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listResponsesRequestToJSON(
  listResponsesRequest: ListResponsesRequest,
): string {
  return JSON.stringify(
    ListResponsesRequest$outboundSchema.parse(listResponsesRequest),
  );
}
export function listResponsesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListResponsesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListResponsesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListResponsesRequest' from JSON`,
  );
}
